import React, { useState, useEffect } from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import axios from "axios";

export default function OverTimeChart1() {
    const [data, setData] = useState([]);
    const [userAverage, setUserAverage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const userId = sessionStorage.getItem("userId");

    useEffect(() => {
        const fetchCumulativeData = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await axios.get(`/user/performance-cumulative-average/${userId}`);
                setData(response.data.data);
                setUserAverage(response.data.userAverage);
                console.log(response.data.data)
                console.log(response.data.userAverage)
            } catch (error) {
                console.error("Error fetching cumulative average data:", error);
                setError("Failed to fetch cumulative average data");
            } finally {
                setLoading(false);
            }
        };

        if (userId) {
            fetchCumulativeData();
        }
    }, [userId]);

    if (loading) return <div>Loading cumulative average score...</div>;
    if (error) return <div>Error loading cumulative average score: {error}</div>;

    return (
        <ResponsiveContainer width="100%" height={400}>
            <LineChart
                data={data}
                margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
            >
                <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                <XAxis
                    dataKey="date"
                    angle={-45}
                    textAnchor="end"
                    height={60}
                    tickFormatter={(tick) => new Date(tick).toLocaleDateString()}
                />
                <YAxis domain={[0, 100]} ticks={[0, 20, 40, 60, 80, 100]} suffix="%" />
                <Tooltip
                    formatter={(value, name) => [`${value}%`, name === "yourAverage" ? "Your average" : "User average"]}
                    labelFormatter={(label) => `Date: ${new Date(label).toLocaleDateString()}`}
                />
                <Legend verticalAlign="top" height={36} />
                <Line
                    type="monotone"
                    dataKey="yourAverage"
                    stroke="#1E88E5"
                    strokeWidth={2}
                    dot={{ r: 1 }}
                    activeDot={{ r: 5 }}
                    name="Your average"
                />
                <Line
                    type="monotone"
                    dataKey="userAverage"
                    stroke="#FF9800"
                    strokeWidth={2}
                    dot={false}
                    name="User average"
                    data={data.map(d => ({ date: d.date, userAverage: userAverage }))} // Create data for user average line
                />
            </LineChart>
        </ResponsiveContainer>
    );
}